import loggerClient from "./bunyan";

function error(msg: string, err: Error, data?: unknown): void {
  loggerClient.error({ msg, err }, data);
}

function warn(msg: string, data?: unknown): void {
  loggerClient.warn({ msg }, data);
}

function info(msg: string, data?: Record<string, unknown>): void {
  loggerClient.info({ msg }, data);
}

function debug(msg: string, data?: Record<string, unknown>): void {
  loggerClient.debug({ msg }, data);
}

function trace(msg: string, data?: Record<string, unknown>): void {
  loggerClient.trace({ msg }, data);
}

const logger = {
  info,
  debug,
  warn,
  error,
  trace,
};

export default logger;
